
<template>
  <v-card
    role="dialog"
    aria-modal="true"
    aria-labelledby="vip-form-title"
    tabindex="-1"
    class="pa-6 primary"
    padding="10"
    id="modalContainer"
    @keydown="checkKeyEvent"
    :ripple="false"
  >
    <v-form
      ref="form"
      v-model="FormValid"
      lazy-validation
      @submit.prevent="addToVips"
    >
      <v-btn
        ref="closeBtn"
        color="red"
        class="mr-4 mb-2 close-button black--text text-capitalize"
        @click="close()"
        x-small
      >
        <v-icon class="black--text">
          mdi-window-close
        </v-icon>
        <div class="sr-only">Close</div>
      </v-btn>

      <h2 id="vip-form-title">
        {{ editing ? hubbdata.vippage.buttontext.updatedetails : hubbdata.vippage.group_label }}
      </h2>

      <v-text-field
        v-model="vip.first_name"
        :rules="nameRules"
        :label="hubbdata.vippage.labels.name"
        :aria-label="hubbdata.vippage.labels.name"
        required
      ></v-text-field>

      <v-text-field
        v-model="vip.surname"
        :label="hubbdata.vippage.labels.surname"
        :aria-label="hubbdata.vippage.labels.surname"
        class="green--text"
      ></v-text-field>

      <v-text-field
        v-model="vip.email"
        :rules="emailRules"
        :label="hubbdata.vippage.labels.email"
        :aria-label="hubbdata.vippage.labels.email"
        required
      ></v-text-field>

      <v-text-field
        v-model="vip.phone"
        :label="hubbdata.vippage.labels.telephone"
        :aria-label="hubbdata.vippage.labels.telephone"
        type="number"
        required
      ></v-text-field>

      <v-avatar
        v-if="vip.image"
      >
        <img
          :src="vip.image"
          alt=""
        />
      </v-avatar>

      <v-file-input
        :label="hubbdata.vippage.buttontext.add"
        :aria-label="hubbdata.vippage.buttontext.add"
        prepend-icon="mdi-camera"
        accept="image/png, image/jpeg"
        @change="handleImageUpload"
        class="primary pb-2 pt-2"
        color="red"
        flat
        solo
        outlined
      >{{hubbdata.vippage.buttontext.add}}</v-file-input>

      <v-btn
        :disabled="!FormValid"
        color="#4caf50"
        class="mr-4 text-capitalize black--text"
        type="submit"
      >
        <span class="black--text" v-if="editing">{{hubbdata.vippage.buttontext.updatedetails}}</span>
        <span class="black--text" v-else>{{hubbdata.vippage.buttontext.savedetails}}</span>
      </v-btn>

      <v-btn
        color="#FE4369"
        class="mr-4 text-capitalize black--text "
        v-if="editing"
        @click="removeVip()"
      >
        <span class="black--text">{{hubbdata.vippage.labels.removevip}}</span>
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import vips from "@/vips";
import hubbdata from "@/hubbdata";
import imageCompression from 'browser-image-compression';

export default {
  name: "VipForm",
  props: {
    editingVip: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    FormValid: false,
    editing: false,
    vip: {
      first_name: '',
      surname: '',
      email: '',
      phone: '',
      image: '',
    },
    nameRules: [
      v => !!v || 'Name is required',
    ],
    surnameRules: [
      v => !!v || 'Surname is required',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    select: null,
    checkbox: false,
  }),
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.closeBtn && this.$refs.closeBtn.$el) {
        this.$refs.closeBtn.$el.focus();
      } else {
        const container = document.getElementById('modalContainer');
        if (container) container.focus();
      }
    });

    if (this.editingVip.first_name) {
      this.vip = this.editingVip;
      this.editing = true;
    }

    let inputs = document.querySelectorAll(".v-file-input input");

    [...inputs].forEach((input) => {
      input.remove();
    });
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);

    document
      .getElementsByClassName("v-application--wrap")[0]
      .setAttribute("aria-hidden", "true");
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.handleKeyup);

    document
      .getElementsByClassName("v-application--wrap")[0]
      .removeAttribute("aria-hidden");
  },
  computed: {
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset () {
      this.$refs.form.reset();
      this.vip = {
        first_name: '',
        surname: '',
        email: '',
        phone: '',
        image: '',
      }
    },
    handleImageUpload(event) {
      var imageFile = event;
      var options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 500,
        useWebWorker: true
      }
      imageCompression(imageFile, options)
        .then((compressedFile) => {
          let reader = new FileReader();
          if (compressedFile){
            reader.readAsDataURL(compressedFile);
            reader.onload = () => {
            this.vip.image = reader.result;
            };
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    },
    close() {
      this.$emit("overlay");
      this.editing = false;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    addToVips() {
      if (this.$refs.form.validate()) {
        if (this.editing === true) {
          vips.commit("editvip", this.vip);
          this.editing = false;
        } else {
          vips.commit("addvip", this.vip);
        }
        this.close();
      }
    },
    removeVip() {
      vips.commit("removevip", this.vip);
      this.close();
    },
    fileSelected(file) {
      let reader = new FileReader();
        if (file){
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.vip.image = reader.result;
          };
        }
    },
    handleKeyup (e) {
      if (this.value && e.key === 'Escape') {
        this.$emit('close');
      }
    },
    checkKeyEvent(event) {
      //only focusable items are buttons, extend list if more items added to modal
      const container = document.querySelector("#modalContainer");
      let focusableList = container.querySelectorAll("input, .close-button");

      if (this.FormValid) {
        focusableList = container.querySelectorAll("input, button");
      }
      // escape early if only 1 or no elements to focus
      if (focusableList.length < 1 && event.key === 'Tab') {
        event.preventDefault();
        return;
      }
      const last = focusableList.length - 1;
      if (
          event.key === 'Tab' &&
          event.shiftKey === false &&
          event.target === focusableList[last]
      ) {
          event.preventDefault();
          focusableList[0].focus();
      } else if (
          event.key === 'Tab' &&
          event.shiftKey === true &&
          event.target === focusableList[0]
      ) {
          event.preventDefault();
          focusableList[last].focus();
      }
    }
  },
}
</script>

<style lang="scss">
.v-overlay {

  .close-button {
    width: 40px !important;
    height: 40px  !important;
    border-radius: 0px;
  }

  .v-form {
    padding-top: 20px;
  }

  .v-avatar {
    display: block;
    margin-bottom: 15px;

    img {
      object-fit: cover;
    }
  }

  .error--text {
    color: #FE4369 !important;

    .v-text-field__details {
      display: block !important;
    }
  }

  .v-label {
    font-size: 16px;
  }
}

.v-overlay__content {

  @media screen and (min-width: 960px) {
    left: 128px;
    position: relative;
  }
}

#modalContainer {
  width: 400px;
  max-width: 400px;

  @media (max-width:400px) {
    width: 300px;

    button {
      margin: 5px;
      width: 100%;
    }
  }

  @media (max-width:300px) {
    width: 250px;
  }
}
</style>